<div class="border border-black rounded-xl w-full">
    <div class="bg-valamargray w-full p-5 rounded-t-xl">
        @if (title) {
            <p>{{ title }}</p>
        }
        <div class="relative">
            <mat-icon class="absolute left-2 top-1/2 -translate-y-1/2 text-lg text-gray-500">search</mat-icon>
            <input
                #sInput
                type="text"
                placeholder="Pretraži..."
                (input)="filter(sInput.value)"
                class="w-full h-10 border rounded-md pl-9 pr-2 text-md focus:outline-none"
            />
        </div>
    </div>

    <div class="p-2">
        <cdk-virtual-scroll-viewport [itemSize]="50" [minBufferPx]="1000" [maxBufferPx]="1000" class="h-64">
            <ul>
                @if (filtering ? filterItems.length === 0 : items.length === 0) {
                    <li class="px-2 py-4">
                        Nema podataka
                    </li>
                }
                <li *cdkVirtualFor="let el of (filtering ? filterItems : items)" class="px-2 py-4">
                    {{ el }}
                </li>
            </ul>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
